import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './index.module.scss';
import Marketing from '../marketing';
import { connect } from 'react-redux';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.PureComponent {

    state = {

    }

    componentDidMount() {
        const { setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
    }
    render() {
        return (
            <div className={styles.flexBoxContainer}>
                <Marketing history={this.props.history} match={this.props.match} />
            </div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};


export default connect(null, { setBreadcrumbPaths })(Main);